import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'marketplace-installs-indicator',
    templateUrl: './installs-indicator.component.html',
    styleUrls: ['./installs-indicator.component.scss'],
    standalone: false
})
export class InstallsIndicatorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
